import React__default, { memo, useMemo } from 'react';
import { useIsPhone, useIsTablet, useIsMobile } from '@sravni/react-utils';

const SUPPORTED_IMAGES_EXTENSIONS = ['jpg', 'jpeg', 'png', 'svg', 'webp'];
const COMPRESSIONS = ['xl', 'l', 'm', 's', 'xs', 't'];
const getOptimizedSrc = (src, compressValue) => {
    if (!src)
        return src;
    const arr = src.split('.');
    const extension = arr[arr.length - 1].toLowerCase();
    if (SUPPORTED_IMAGES_EXTENSIONS.includes(extension)) {
        arr.splice(arr.length - 2, 1, `${arr[arr.length - 2]}-${compressValue}`);
        return arr.join('.');
    }
    else {
        return src;
    }
};
// TODO: проверить, может можно перейти на @sravni/react-image
const OptimizedImg = memo(({ src, compression, ...props }) => {
    const isPhone = useIsPhone();
    const isTablet = useIsTablet();
    const isMobile = useIsMobile();
    const compressValue = useMemo(() => {
        let output = 0;
        if (isTablet)
            output += 2;
        if (isPhone)
            output += 3;
        if (compression === 'auto') {
            return COMPRESSIONS[Math.max(0, output)];
        }
        else if (isMobile) {
            return compression[1];
        }
        else
            return compression[0];
    }, [compression, isMobile, isPhone, isTablet]);
    // TODO: доделать прелодер для картинок
    const getSrc = useMemo(() => {
        return getOptimizedSrc(src, compressValue);
    }, [compressValue, src]);
    return React__default.createElement("img", { src: getSrc, ...props });
});

export { OptimizedImg, getOptimizedSrc };
//# sourceMappingURL=OptimizedImg.js.map
